module.exports = __webpack_public_path__ + "static/media/BreaksGroup.62e56493.svg";